"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _lodash = require("lodash");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useGlobalBan = function useGlobalBan(_ref) {
  var client = _ref.client;
  var _useState = (0, _react.useState)(client !== null && client !== void 0 && client.user.banned ? {
      expiration: client.user.ban_expires
    } : undefined),
    _useState2 = _slicedToArray(_useState, 2),
    ban = _useState2[0],
    setBan = _useState2[1];
  (0, _react.useEffect)(function () {
    if ((0, _lodash.isBoolean)(client === null || client === void 0 ? void 0 : client.user.banned)) {
      setBan(client.user.banned ? {
        expiration: client.user.ban_expires
      } : undefined);
    }
  }, [client, client === null || client === void 0 ? void 0 : client.user, client === null || client === void 0 ? void 0 : client.user.banned]);
  var userBannedHandler = (0, _react.useCallback)(function (e) {
    // events with channel_id are tracked by useChannelBan
    if (!e.channel_id && client.user.id === e.user.id) {
      setBan({
        expiration: e.expiration
      });
    }
  }, [client]);
  var userUnbannedHandler = (0, _react.useCallback)(function (e) {
    if (!e.channel_id && client.user.id === e.user.id) {
      setBan(null);
    }
  }, [client]);
  (0, _react.useEffect)(function () {
    var clientBanSubscription;
    var clientUnbanSubscription;
    if (client) {
      clientBanSubscription = client === null || client === void 0 ? void 0 : client.on('user.banned', userBannedHandler);
      clientUnbanSubscription = client === null || client === void 0 ? void 0 : client.on('user.unbanned', userUnbannedHandler);
    }
    return function () {
      if (clientBanSubscription) {
        clientBanSubscription.unsubscribe();
      }
      if (clientUnbanSubscription) {
        clientUnbanSubscription.unsubscribe();
      }
    };
  }, [client]);
  return {
    ban: ban
  };
};
var _default = useGlobalBan;
exports.default = _default;